import React, { useCallback } from 'react';
import { LOCALES } from 'src/constants/main';
import { ILangTextValidation, TBooleanInNumber } from 'src/types/main';
import InputAlt from 'src/view/components/Controls/InputAlt/InputAlt';
import MultiLanguageInput from 'src/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import { defaultIntegrationTooltipOptions, RESTRICTION_ACCESS } from 'src/constants/integrations';
import IntegrationTooltip from 'src/view/components/IntegrationTooltip/IntegrationTooltip';
import { isDisabledByPos } from 'src/utils/helpers';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  name: {
    enName?: string;
    arName?: string;
  };
  externalId?: string | number;
  status: TBooleanInNumber;
  validation: ILangTextValidation;
  disabled?: boolean;
  nameInputTitle: string;
  posNameRestriction?: RESTRICTION_ACCESS;
  posAvailabilityRestriction?: RESTRICTION_ACCESS;
  changeName: (value: string, currentLanguage: LOCALES) => void;
  changeExternalId: (value: string | number) => void;
  changeAvailability: (status: TBooleanInNumber) => void;
  setValidation: () => void;
}

const MenuManagTabItemMainDetails: React.FC<IProps> = (props: IProps): JSX.Element => {
  const changeName = useCallback(
    (value: string, currentLanguage: LOCALES) => {
      props.changeName(value, currentLanguage);
      // update validation
      if (!props.validation.enValid || !props.validation.arValid) props.setValidation();
    },
    [props.validation.enValid, props.validation.arValid]
  );

  return (
    <div className="mt-6 d-flex flex-column">
      <div className="d-flex flex-row">
        <IntegrationManager setting={props.posNameRestriction} wrapperClassName="d-flex flex-column mr-3">
          <Text
            type={TEXT.BLOCK_HEADER}
            text={props.nameInputTitle}
            disabled={isDisabledByPos(props.posNameRestriction) || props.disabled}
            required
          />
          <MultiLanguageInput
            maxLength={50}
            enText={props.name.enName}
            arText={props.name.arName}
            onChangeValue={changeName}
            validation={props.validation}
            tooltip={
              isDisabledByPos(props.posNameRestriction) && !props.disabled
                ? { ...defaultIntegrationTooltipOptions, wrapperClassName: 'full-height' }
                : undefined
            }
            disabled={isDisabledByPos(props.posNameRestriction) || props.disabled}
            className="mt-2"
          />
        </IntegrationManager>
        <div className="d-flex flex-column">
          <Text type={TEXT.BLOCK_HEADER} text="external_id" disabled={props.disabled} />
          <InputAlt
            value={props.externalId}
            className="menu-manag-tab-item-main-details__input mt-2"
            onChangeValue={(value) => props.changeExternalId(value)}
            disabled={props.disabled}
          />
        </div>
      </div>
      <IntegrationManager setting={props.posAvailabilityRestriction} wrapperClassName="d-flex flex-row align-items-center mt-4">
        <IntegrationTooltip isVisible={isDisabledByPos(props.posAvailabilityRestriction) && !props.disabled}>
          <Switcher status={props.status} onChange={props.changeAvailability} disabled={props.disabled} />
        </IntegrationTooltip>
        <Text type={TEXT.SWITCHER_LABEL} text="availability" disabled={isDisabledByPos(props.posAvailabilityRestriction) || props.disabled} />
      </IntegrationManager>
    </div>
  );
};

export default MenuManagTabItemMainDetails;
